<template>
  <layout-gestao>
    <print-properties
      :internalCode="moduleCode"
      :panelID="pageID"
      :title="pageTitle"
      :report="true"
      :reportHelp="$t(`${pageID}.help.settings`)"
      name="print-inventory-properties"
    />
  </layout-gestao>
</template>

<script>
    import mixin from '../../../../mixin';

export default {
    components: {
        PrintProperties: () => import(/* webpackChunkName: "print-properties" */ '@/app/shared/components/manage/print/ManagePrintProperties'),
    },
    mixins: [
        mixin,
    ],
    data() {
      const pageID = 'municipal_interventions_reports';
        return {
            pageID: pageID,
            pageTitle: this.$t(`${pageID}.title`),
        }
    },
    computed: {
    },
    methods: {

    },
}
</script>
